import { lazy } from "react";
import { RouteObject } from "react-router-dom";

const HomePage = lazy(() => import("../pages/home/page"));
const AboutPage = lazy(() => import("../pages/about/page"));
const BlogPage = lazy(() => import("../pages/blog/page"));
const BlogArticlePage = lazy(() => import("../pages/blog-article/page"));
const CategoryPage = lazy(() => import("../pages/category/page"));
const ContactPage = lazy(() => import("../pages/contact/page"));
const SubmitToolPage = lazy(() => import("../pages/submit-tool/page"));
const ToolDetailPage = lazy(() => import("../pages/tool-detail/page"));
const SearchPage = lazy(() => import("../pages/search/page"));
const PrivacyPolicyPage = lazy(() => import("../pages/privacy-policy/page"));
const TermsOfServicePage = lazy(() => import("../pages/terms-of-service/page"));
const CookiePolicyPage = lazy(() => import("../pages/cookie-policy/page"));
const AffiliateDisclosurePage = lazy(() => import("../pages/affiliate-disclosure/page"));
const NotFoundPage = lazy(() => import("../pages/NotFound"));
const CategoriesPage = lazy(() => import("../pages/categories/page"));
const QuizPage = lazy(() => import("../pages/quiz/page"));
const ComparePage = lazy(() => import("../pages/compare/page"));
const AffiliatesPage = lazy(() => import("../pages/affiliates/page"));

const routes: RouteObject[] = [
  {
    path: "/",
    element: <HomePage />,
  },
  {
    path: "/categories",
    element: <CategoriesPage />,
  },
  {
    path: "/about",
    element: <AboutPage />,
  },
  {
    path: "/blog",
    element: <BlogPage />,
  },
  {
    path: "/blog/:slug",
    element: <BlogArticlePage />,
  },
  {
    path: "/category/:categorySlug",
    element: <CategoryPage />,
  },
  {
    path: "/contact",
    element: <ContactPage />,
  },
  {
    path: "/submit-tool",
    element: <SubmitToolPage />,
  },
  {
    path: "/tool/:slug",
    element: <ToolDetailPage />,
  },
  {
    path: "/search",
    element: <SearchPage />,
  },
  {
    path: "/privacy-policy",
    element: <PrivacyPolicyPage />,
  },
  {
    path: "/terms-of-service",
    element: <TermsOfServicePage />,
  },
  {
    path: "/cookie-policy",
    element: <CookiePolicyPage />,
  },
  {
    path: "/affiliate-disclosure",
    element: <AffiliateDisclosurePage />,
  },
  {
    path: "/affiliates",
    element: <AffiliatesPage />,
  },
  {
    path: "/quiz",
    element: <QuizPage />,
  },
  {
    path: "/compare",
    element: <ComparePage />,
  },
  {
    path: "*",
    element: <NotFoundPage />,
  },
];

export default routes;